import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	clearFiltersButtonText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	goBackToFilterButtonText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	clearFiltersButtonText: {
		id: 'issue-navigator.jql-builder.reset-button.clear-filters-button-text',
		defaultMessage: 'Clear filters',
		description: 'The text for the clear filters button in refinement bar',
	},
	goBackToFilterButtonText: {
		id: 'issue-navigator.jql-builder.reset-button.go-back-to-filter-button-text',
		defaultMessage: 'Go back to filter',
		description: 'The text for the reset filter button in refinement bar',
	},
});
export default messages;
